module.exports = __webpack_public_path__ + "static/assets/333b5b49e1753ebb8908212c06a354a3.png";